// extracted by mini-css-extract-plugin
module.exports = {"nav":"bread-crumbs_nav__EB6oS","crumbs":"bread-crumbs_crumbs__vyJ4k","active":"bread-crumbs_active__zFUJG"};